import { useQuery } from "@tanstack/react-query";

/**
 * Task #586 — Client-side companion to `evaluateAgencyDashboardAccess`.
 *
 * Calls the small `/api/agency/access` probe so the nav entry and the
 * agency-page route gate render exactly the same answer the server would
 * give. Never throws — falls back to "not enabled" on errors so the
 * feature stays invisible.
 */
export interface AgencyDashboardAccessResponse {
  enabled: boolean;
}

export function useAgencyDashboardAccess() {
  return useQuery<AgencyDashboardAccessResponse>({
    queryKey: ["/api/agency/access"],
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
